import PropTypes from 'prop-types';
import React from 'react';

import Radiobutton from '../Radio/radioButton';

import './CCRRateBox.css';

export default class CCRRateBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {}
    };
  }

  componentWillMount() {
    var values = {};
    if (this.props._value !== undefined) {
      values = this.props._value;
      if (this.props._value[this.props.subNames[0]] === undefined) {
        values = {
          ...this.props._value,
          [this.props.subNames[0]]: this.props.radioValues[0]
        };
      } if (this.props._value[this.props.subNames[6]] === undefined) {
        values = {
          ...this.props._value,
          [this.props.subNames[6]]: this.props.radioValues[3]
        };
      }
      if (this.props._value[this.props.subNames[10]] === undefined) {
        values = {
          ...this.props._value,
          [this.props.subNames[10]]: this.props.radioValues[5]
        };
      }
    } else {
      values[this.props.subNames[0]] = this.props.radioValues[0];
      values[this.props.subNames[6]] = this.props.radioValues[3];
      //values = {[this.props.subNames[0]]: this.props.radioValues[0]};
    }
    this.setState({ values: values });
  }

  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props._value) !== JSON.stringify(nextProps._value)) {
      const values = { ...nextProps._value, ...this.state.values }
      if (nextProps.subNames && nextProps.subNames[0] && values[nextProps.subNames[0]] === undefined) {
        values[nextProps.subNames[0]] = nextProps.radioValues[0]
      }
      this.setState({ values: values });
    }
  }

  handleInputBoxChange = (event) => {
    this.setState({ values: { ...this.state.values, [event.target.name]: event.target.value } }, () => {
      this.props.setInputvalue(this.state.values, this.props.name);
    });
  }

  handleRadioChange = (value, name) => {
    name = name.split('-').pop();
    var values = { ...this.state.values, [name]: value };

    if (name === this.props.subNames[0]) {
      if (value === this.props.radioValues[0]) {
        values[this.props.subNames[7]] = undefined;
        values[this.props.subNames[6]] = this.props.radioValues[3]
      } else {
        values[this.props.subNames[2]] = '';
        values[this.props.subNames[3]] = '';
        values[this.props.subNames[4]] = '';
        values[this.props.subNames[5]] = '';
        values[this.props.subNames[6]] = '';
        if (this.props.subNames[8]) {
          values[this.props.subNames[8]] = '';
        }
        if (this.props.subNames[9]) {
          values[this.props.subNames[9]] = '';
        }
      }
    }

    if (name === "marginBaseRate" && value === true) {
      values.fixedValue = ''
    }
    if (name === "fixedValue" && value === false) {
      values.marginBaseRate = ''
    }

    this.setState({ values }, () => {
      this.props.setInputvalue(values, this.props.name);
    });
  }

  isAccountLimitsCCRRateBox = () => {
    return this.props.name === "credit" || this.props.name === "debit"
  }

  render() {
    return (
      <div className={this.isAccountLimitsCCRRateBox() ? "ccr-rate-box account-limits-ccr-rate-box" : "ccr-rate-box"}>
        <label className={this.isAccountLimitsCCRRateBox() ? "ccr-rate-box__label gdocs-font-bold" : "ccr-rate-box__label"}>{this.props.boxLabel}</label>
        <label className="radio-label">
          {this.props.subLabels[0] || "Set base rate and spread"}
          <Radiobutton setInputvalue={this.handleRadioChange}
            name={`${this.props.name}-${this.props.subNames[0]}`}
            disabled={this.props.disabled}
            _value={this.state.values[this.props.subNames[0]]}
            value={this.props.radioValues[0] || "baseRate"} />
        </label>
        <label className="radio-label">
          {this.props.subLabels[1] || "Set fixed rate"}
          <Radiobutton setInputvalue={this.handleRadioChange}
            name={`${this.props.name}-${this.props.subNames[1]}`}
            disabled={this.props.disabled}
            _value={this.state.values[this.props.subNames[1]]}
            value={this.props.radioValues[1] || "fixedRate"} />
        </label>
        {
          this.state.values.interestRateType ? (
            <div className="ccr-rate-box__combo-box">
              {
                this.state.values.interestRateType === "baseRate" ? (
                  <div className="ccr-rate-box__combo-box__row">
                    <div className='ccr-rate-group-by'>
                      <div className="combo-box">
                        <label className="combo-box__label">{this.props.subLabels[2] || "Base rate"}</label>
                        <input className="combo-box__input"
                          type="text"
                          name={this.props.subNames[2]}
                          disabled={this.props.disabled}
                          value={this.state.values[this.props.subNames[2]] || ''}
                          maxLength={this.props.maxChars[2]}
                          onChange={this.handleInputBoxChange} />
                      </div>
                      {!this.props.disabled
                        ? <div className="combo-box">
                          <label className="combo-box__label">{this.props.subLabels[3] || "Code"}</label>
                          <input className="combo-box__input"
                            type="text"
                            name={this.props.subNames[3]}
                            value={this.state.values[this.props.subNames[3]] || ''}
                            maxLength={this.props.maxChars[3]}
                            onChange={this.handleInputBoxChange}
                            placeholder={this.props.defaultValue && this.props.defaultValue[1]} />
                        </div>
                        : ''}
                    </div>
                    <div className='ccr-rate-group-by'>
                      <div className="combo-box">
                        <label className="combo-box__label">{this.props.subLabels[4] || "Spread"}</label>
                        <input className="combo-box__input"
                          type="text"
                          name={this.props.subNames[4]}
                          disabled={this.props.disabled}
                          value={this.state.values[this.props.subNames[4]] || ''}
                          maxLength={this.props.maxChars[4]}
                          onChange={this.handleInputBoxChange} />
                      </div>

                      <label className="radio-label">
                        {this.props.subLabels[5] || "Margin % (of base rate)"}
                        <Radiobutton setInputvalue={this.handleRadioChange}
                          name={`${this.props.name}-${this.props.subNames[5]}`}
                          disabled={this.props.disabled}
                          _value={this.state.values[this.props.subNames[5]]}
                          value={this.props.radioValues[2] || "true"} />
                      </label>
                      <label className="radio-label">
                        {this.props.subLabels[6] || "Fixed value %"}
                        <Radiobutton setInputvalue={this.handleRadioChange}
                          name={`${this.props.name}-${this.props.subNames[6]}`}
                          disabled={this.props.disabled}
                          _value={this.state.values[this.props.subNames[6]]}
                          value={this.props.radioValues[3] || "false"} />
                      </label>
                    </div>
                    <div className='ccr-rate-group-by'>
                      {this.props.subLabels[8] ? <div className="combo-box">
                        <label className="combo-box__label">{this.props.subLabels[8] || "Minimum interest"}</label>
                        <input className="combo-box__input"
                          type="text"
                          name={this.props.subNames[8]}
                          disabled={this.props.disabled}
                          placeholder={this.props.defaultValue[8]}
                          value={this.state.values[this.props.subNames[8]] || ''}
                          maxLength={this.props.maxChars[8]}
                          onChange={this.handleInputBoxChange} />
                      </div> : null}
                      {this.props.subLabels[9] ? <div className="combo-box">
                        <label className="combo-box__label">{this.props.subLabels[9] || "Maximum interest"}</label>
                        <input className="combo-box__input"
                          type="text"
                          name={this.props.subNames[9]}
                          disabled={this.props.disabled}
                          placeholder={this.props.defaultValue[9]}
                          value={this.state.values[this.props.subNames[9]] || ''}
                          maxLength={this.props.maxChars[9]}
                          onChange={this.handleInputBoxChange} />
                      </div> : null}
                    </div>
                  </div>
                ) : ''
              }
              {
                this.state.values.interestRateType === "baseRate" ? (
                  <div className="ccr-rate-box__combo-box__row">

                  </div>
                ) : ''

              }
              {
                this.state.values.interestRateType === "fixedRate" ? (
                  <div className="ccr-rate-box__combo-box__row">
                    <div className="combo-box">
                      <label className="combo-box__label">{this.props.subLabels[7] || "Fixed rate"}</label>
                      <input className="combo-box__input"
                        type="text"
                        name={this.props.subNames[7]}
                        disabled={this.props.disabled}
                        value={this.state.values[this.props.subNames[7]] || ''}
                        maxLength={this.props.maxChars[7]}
                        onChange={this.handleInputBoxChange} /> %
                    </div>
                  </div>
                ) : ''
              }
              {this.props.subLabels[10] ?
                <div className='gdocs-mt-8'>
                  <span className='radio-label'>Negative Credit Interest</span>
                  <label className="radio-label">
                    Yes
                    <Radiobutton setInputvalue={this.handleRadioChange}
                      name={`${this.props.name}-${this.props.subNames[10]}`}
                      disabled={this.props.disabled}
                      _value={this.state.values[this.props.subNames[10]]}
                      value={this.props.radioValues[4] || true} />
                  </label>
                  <label className="radio-label">
                    No
                    <Radiobutton setInputvalue={this.handleRadioChange}
                      name={`${this.props.name}-${this.props.subNames[10]}`}
                      disabled={this.props.disabled}
                      _value={this.state.values[this.props.subNames[10]]}
                      value={this.props.radioValues[5] || false} />
                  </label>
                </div>
                : null}
            </div>
          ) : ''
        }
      </div>
    )
  }
}

CCRRateBox.defaultProps = {
  subNames: [],
  subLabels: [],
  maxChars: []
}

CCRRateBox.propTypes = {
  boxLabel: PropTypes.string.isRequired,
  subLabels: PropTypes.array,
  maxChars: PropTypes.array,
  subNames: PropTypes.array.isRequired,
  radioValues: PropTypes.array.isRequired,
  setInputvalue: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/common/CCRRateBox/CCRRateBox.js